import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withSiteData } from 'react-static';

const Player = styled.iframe`
  .inapp-webview & {
    display: none;
  }
  .ios-webview & {
    display: none;
  }
  border: 1px solid var(--c-manatee);
`;

const EmbeddablePlayer = ({ id, appDomain, type = 'playlist' }) => {
  return (
    <Player
      src={`${appDomain}/player?${type}_id=${id}&theme=dark`}
      width="100%"
      height="400"
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
      title="IDAGIO Player"
    />
  );
};

EmbeddablePlayer.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(['playlist', 'album', 'recording']),
  appDomain: PropTypes.string.isRequired,
};

export default withSiteData(EmbeddablePlayer);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/EmbeddablePlayer.js